import { Injectable } from '@angular/core'
import { Select, State, Action, StateContext, Selector, NgxsOnInit, Store, NgxsSimpleChange } from '@ngxs/store'
import { Observable } from 'rxjs';
import { UserState } from 'src/app/state-man/state/user.state';
import { User } from 'src/app/state-man/models/user.model';
import { FormTypeActions } from '../actions/form-type.actions';
import { FormType } from '../models/form-type.model';
import { FormTypeService } from 'src/app/services/form-type.service';
import { StorageService } from 'src/app/services/storage.service';
import { stateContentChanged } from './state-content-changed'

export class FormTypeStateModel {
    is_refreshing: boolean
    form_type: FormType[]
}

@State<FormTypeStateModel>({
    name: 'form_type',
    defaults: {
        is_refreshing: true,
        form_type: []
    }
})
@Injectable()
export class FormTypeState implements NgxsOnInit {
    @Select(UserState.getUser) user$: Observable<User>

    constructor(        
        private formTypeService: FormTypeService,
        private store: Store,
        private storageService: StorageService
    ) {}

    async ngxsOnInit(ctx: StateContext<FormTypeStateModel>) {                
        this.user$.subscribe(async (user: User) => {            
            if (user.is_logged_in) {     
                this.storageService.events.subscribe(async (status: any) => {
                    if (this.storageService.is_initialized) {                     
                        await this.reloadStateFromStorage()                        
                    }
                })                           
            }
        }) 
    } 

    async ngxsOnChanges(change: NgxsSimpleChange) {                       
        if (this.storageService.is_initialized && stateContentChanged(change)) {
            const state_model: FormTypeStateModel = change.currentValue
            this.storageService.set('form_types', JSON.stringify(state_model))    
        }      
    }

    async reloadStateFromStorage() {        
        const json = await this.storageService.get('form_types');        
        if (json) {
            const state_model: FormTypeStateModel = JSON.parse(json)
            if (state_model) {
                this.store.dispatch(new FormTypeActions.Init(state_model));
                return
            }
        }
        this.store.dispatch(new FormTypeActions.Refresh())
    }

    async reloadStateFromApi() : Promise<boolean> {    
        const objs = await this.formTypeService.getAll()    
        if (objs != null) {
          // The service has already run buildMany over the response, so the
          // rows arriving here are built models. Building them a second time
          // allocated a duplicate object for every row and, where buildOne
          // rebuilds children, re-walked those too.
          this.store.dispatch(new FormTypeActions.Set(objs))
          return true
        }
        return false
    }
  
    @Selector()
    static getState(state: FormTypeStateModel) {
        return state
    }

    @Selector()
    static getIsRefreshing(state: FormTypeStateModel) {
        return state.is_refreshing
    }

    @Selector()
    static getAll(state: FormTypeStateModel) {
        return state.form_type
    }

    @Action(FormTypeActions.Refresh)
    async refresh({patchState}: StateContext<FormTypeStateModel>, {  }:FormTypeActions.Refresh) {
        patchState({is_refreshing: true})
        if (!await this.reloadStateFromApi()) {            
            patchState({is_refreshing: false})
        }
    }
    
    @Action(FormTypeActions.Init)
    init({setState, getState}: StateContext<FormTypeStateModel>, { payload }:FormTypeActions.Init) {                  
        const state = getState()
        payload.is_refreshing = state.is_refreshing
        setState(payload)
        this.store.dispatch(new FormTypeActions.Refresh())
    }

    @Action(FormTypeActions.Set)
    set({setState}: StateContext<FormTypeStateModel>, { payload }:FormTypeActions.Set) {             
        setState({    
            is_refreshing: false,        
            form_type: payload
        })
    }
}
